export default __webpack_public_path__ + "images/BC.b502736.png";